<script setup lang="ts">
import getMeta from "@/classes/getMeta";
import PageHeader from "~/components/layout/PageHeader.vue";
import PGHS from "@/data/docs/pghs";
import REPORTS from "@/data/docs/reports";
import XDAC from "@/data/docs/xdac";
import XRAD from "@/data/docs/xrad";
import DemoList from "~/components/docs/DemoList.vue";

const DOC_ITEMS = [ PGHS, REPORTS, XDAC, XRAD ];

definePageMeta({
  layout: "default",
  name: "demo",
});

useHead(getMeta(
    `XSQUARE`,
    `XSQUARE`,
));
</script>

<template>
  <page-header
    h1="Demo"
    :show-more-button="false"
  />

  <div class="container content-page">
    <demo-list
      :items="DOC_ITEMS"
    />
<!--    <get-more-lessons/>-->
  </div>
</template>
